// ========== BOM 功能 ==========
let bomItems = JSON.parse(localStorage.getItem('bomItems') || '[]');

function updateBOMCount() {
  document.getElementById('bomCount').textContent = bomItems.length;
}

function addToBOM(button) {
  const row = button.closest('.product-row');
  const brand = row.querySelector('.brand-cell').textContent.trim();
  const partNumber = row.querySelector('.part-number-cell').textContent.trim();
  const packageType = row.querySelector('.package-cell').textContent.trim();
  const year = row.querySelector('.year-input').value || '';
  const qty = row.querySelector('.qty-input').value || '';
  const price = row.querySelector('.price-input').value || '';

  if (qty && qty < 1) {
    alert('Quantity cannot be less than 1');
    return;
  }

  const item = { id: Date.now(), brand, partNumber, packageType, year, qty, price };
  bomItems.push(item);
  localStorage.setItem('bomItems', JSON.stringify(bomItems));
  updateBOMCount();
}

function toggleBOMModal() {
  const modal = document.getElementById('bomModal');
  modal.classList.toggle('active');
  if (modal.classList.contains('active')) renderBOMList();
}

function renderBOMList() {
  const listContainer = document.getElementById('bomList');
  const t = window.bomTexts || {};
  const headerHtml = `
    <div class="bom-item bom-header">
      <div class="bom-item-field"><div class="bom-item-label">${t.brand || 'Brand'}</div></div>
      <div class="bom-item-field"><div class="bom-item-label">${t.partNumber || 'Part Number'}</div></div>
      <div class="bom-item-field"><div class="bom-item-label">${t.package || 'Package'}</div></div>
      <div class="bom-item-field"><div class="bom-item-label">${t.year || 'Year'}</div></div>
      <div class="bom-item-field"><div class="bom-item-label">${t.qty || 'Qty'}</div></div>
      <div class="bom-item-field"><div class="bom-item-label">${t.price || 'Price'}</div></div>
      <div class="remove-btn" style="visibility: hidden;"></div>
    </div>`;

  if (bomItems.length === 0) {
    listContainer.innerHTML = headerHtml + '<p class="empty-message"></p>';
    return;
  }

  let html = headerHtml;
  bomItems.forEach((item) => {
    html += `
      <div class="bom-item">
        <div class="bom-item-field"><div class="bom-item-value" title="${item.brand}">${item.brand}</div></div>
        <div class="bom-item-field"><div class="bom-item-value" title="${item.partNumber}">${item.partNumber}</div></div>
        <div class="bom-item-field"><div class="bom-item-value">${item.packageType}</div></div>
        <div class="bom-item-field"><div class="bom-item-value">${item.year}</div></div>
        <div class="bom-item-field"><div class="bom-item-value">${item.qty}</div></div>
        <div class="bom-item-field"><div class="bom-item-value">${item.price}</div></div>
        <button class="remove-btn" onclick="removeFromBOM(${item.id})" title="Remove">×</button>
      </div>`;
  });
  listContainer.innerHTML = html;
}

function removeFromBOM(id) {
  bomItems = bomItems.filter((item) => item.id !== id);
  localStorage.setItem('bomItems', JSON.stringify(bomItems));
  updateBOMCount();
  renderBOMList();
}

function clearBOM() {
  bomItems = [];
  localStorage.setItem('bomItems', JSON.stringify(bomItems));
  updateBOMCount();
  renderBOMList();
}

function sendWhatsApp() {
  if (bomItems.length === 0) { alert('BOM is empty'); return; }
  const t = window.bomTexts || {};
  let message = '📋 ' + (t.rfqTitle || 'RFQ') + '\n';
  message += '🏢香港嘉信芯貿科技有限公司\n';
  message += '🏢 HONG KONG JASIN SEMICONDUCTOR TECHNOLOGY COMPANY LIMITED\n';
  message += '🌐 www.jasinchip.com.hk 📧 jason@jasinchip.com.hk\n';
  message += '⚠️ ' + (t.paymentNotice || '') + '\n\n';
  bomItems.forEach((item, index) => {
    message += `${index + 1}. ${item.partNumber}\n`;
    message += `  ${t.brand || 'Brand'}: ${item.brand}  |  ${t.package || 'Package'}: ${item.packageType}  |  ${t.year || 'Year'}: ${item.year}  |  ${t.qty || 'Qty'}: ${item.qty}  |  ${t.price || 'Price'}: ${item.price}\n\n`;
  });
  message += '  ' + (t.quoteRequest || 'Please provide your best price and lead time. Thank you!') + '\n';
  const encodedMessage = encodeURIComponent(message);
  window.open(`https://api.whatsapp.com/send?phone=85252099651&text=${encodedMessage}`, '_blank');
}

function goToProduct(element) {
  const row = element.closest('.product-row');
  const productUrl = row.getAttribute('data-product-url');
  if (productUrl) window.location.href = productUrl;
}

document.addEventListener('DOMContentLoaded', function () {
  updateBOMCount();
  document.getElementById('bomModal').addEventListener('click', function (e) {
    if (e.target === this) toggleBOMModal();
  });
});
